import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import merchantApi from "../api/merchantApi";
import { ACCESS_TOKEN_KEY } from "../utils/contants";

const useToken = () => {
  const [loading, setLoading] = useState(false);
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  
  const getToken = async () => {
    setLoading(true);
    const result = await merchantApi.getToken();

    setLoading(false);
    if (!result.ok) {
      return
      // return toast.error(result.problem);
    }
    if (!result.data?.success) {
      return
      // return toast.error(result.data?.data.message);
    }
    Cookies.set(ACCESS_TOKEN_KEY, result.data.data.access_token, {
      secure: true,
      expires: 1,
    });
  };

  useEffect(() => {
    if (!token) {
      getToken();
    }
  }, [token]);

  return { loading, token };
};

export default useToken;
